import React, { useEffect, useState, useRef } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { connect } from 'react-redux';
import { reportDWH, initPage, goToPage, setDetailsProducts } from './PersonalAreaInvoicesSlice';
import { prepareInvoicesAsync, getAllInvoicesAsync, getFullMainAsync } from './PersonalAreaInvoicesAsyncThunk';

//pages
import InvoicePage from './pages/InvoicesPage';
import QuestionsAndAnswersPage from './pages/QuestionsAndAnswersPage';
import CallsDetailsPage from './pages/CallsDetailsPage';
import OtpVerifyCodePage from './pages/OtpVerifyCodePage/OtpVerifyCodePage';

const PersonalAreaInvoices = (props) => {
  let currentView = null;

  useExtendedEffect((runSideEffects) => {
   getData();
    if (runSideEffects()) {}
  }, []);

  async function getData() {
    await props.prepareInvoicesAsync({epiData: props.iContent});
    props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText: 'Invoice Page Displayed' });
  };

  useClearStateResetFlag();

  switch (props.page) {
    case 'otpVerifyCodePage' :  currentView = <OtpVerifyCodePage />; break;
    case 'invoicesPage': currentView = <InvoicePage context={props.context} iContent={props.iContent} />; break;
    case 'questionsAndAnswersPage': currentView = <QuestionsAndAnswersPage context={props.context} iContent={props.iContent} />; break;
    case 'callsDetailsPage' :  currentView = <CallsDetailsPage context={props.context} iContent={props.iContent} />; break;    
  }

  return (
    <div className='personal-area-invoices-block-wrapper'>
      {currentView}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.personalAreaInvoicesPage.page,
    guidId: state.personalAreaInvoicesPage.guidId,
    detailsProducts: state.personalAreaInvoicesPage.detailsProducts
  };
};

const mapDispatchToProps = {
  reportDWH,
  initPage,
  goToPage,
  prepareInvoicesAsync,
  getAllInvoicesAsync,
  getFullMainAsync,
  setDetailsProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalAreaInvoices);
